import { ISupportTypeFrequenciesQuery, ISupportTypeFrequency, queryKeys } from '../../shared';
import { useSave } from '../../shared/hooks/new-base.hook';
import { useList, UseListParams } from '../../shared/hooks/new-read-only.hook';
import { supportTypeFrequencyClient } from '../clients/support-type-frequency.client';

const client = supportTypeFrequencyClient;
const listKey = queryKeys.SUPPORT_TYPES_FREQUENCIES;
const itemKey = queryKeys.SUPPORT_TYPES_FREQUENCY;

export function useSupportTypesFrequencyList(
    ...args: UseListParams<ISupportTypeFrequency, ISupportTypeFrequenciesQuery>
) {
    return useList(client, listKey, args);
}

export function useSaveSupportTypesFrequency() {
    return useSave(client, listKey, itemKey);
}
